
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-90cc6154&scoped=true!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./WheelFragment.vue")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./WheelFragment.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-90cc6154!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./WheelFragment.vue"),
  /* scopeId */
  "data-v-90cc6154",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/views/activity/WheelFragment.vue
// module id = 387
// module chunks = 2